import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IPassengerChangeTicketAction } from "../../../Orchestrator/Types/Interface/EventParams/TicketAction";

export class PassengerNextPrevAction extends BaseAction<void, IPassengerChangeTicketAction> {

    override async run(): Promise<void> {
        try {
            const { passengerIndex } = this.params!;
            if (typeof passengerIndex === "number" && passengerIndex >= 0) {
                updateRecoilState("currentPassengerTicketAtom", passengerIndex);
            }
        } catch (error) {
            console.error("Error in PassengerNextPrevAction:", error);
        }
    }
}

// Create a singleton instance
export const passengerNextPrevAction = new PassengerNextPrevAction(); 